import { render, staticRenderFns } from "./invoiceedit.vue?vue&type=template&id=f2b89e26&scoped=true"
import script from "./invoiceedit.vue?vue&type=script&lang=ts"
export * from "./invoiceedit.vue?vue&type=script&lang=ts"
import style0 from "./invoiceedit.vue?vue&type=style&index=0&id=f2b89e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b89e26",
  null
  
)

export default component.exports